/**
 * FICHA DA ASSINATURA (modal do olho): os números na frente.
 * Prévia aprovada: https://claude.ai/artifact/Ci8tFaP5pwQKMng4YzAU8U
 *
 * Até 10/2026 o olho abria um catálogo: a descrição comercial de cada produto
 * vinha aberta, e uma assinatura de 6 itens (CONCEITO, a Licença de Sistema
 * com 9 linhas de texto) não cabia na tela. Na AGGER (87 ramais, 5 itens,
 * 3 DDRs) era preciso rolar o modal inteiro para chegar no subtotal.
 */
import { isAdjustmentDue } from './adjustmentVerification';

const num = (v: any) => Number(v) || 0;
const codigo = (i: any, products: any[]) =>
  String(i?.productCode || products.find((p) => Number(p.id) === Number(i?.productId))?.code || '');

/** Ramais contratados: soma das quantidades dos itens de ramal. */
export const ramaisDaAssinatura = (items: any[], products: any[] = []) =>
  (items || []).filter((i) => /RAMAL/i.test(codigo(i, products))).reduce((s, i) => s + num(i.quantity || 0), 0);

export type TomDoReajuste = 'vencido' | 'proximo' | 'ok' | 'nenhum';

export interface SituacaoDoReajuste {
  texto: string;
  tom: TomDoReajuste;
  dica: string;
}

/**
 * A situação do reajuste numa palavra, com a MESMA regra da tela de
 * Assinaturas: "vencido" só quando a data-base passou E foi conferida no
 * documento (`isAdjustmentDue`). Data não conferida é chute de cadastro e não
 * acende alerta.
 */
export function situacaoDoReajuste(contract: any, diasAte: number | null, dataCurta: (d: any) => string): SituacaoDoReajuste {
  if (!contract?.nextAdjustmentDate) return { texto: '—', tom: 'nenhum', dica: 'Sem data de reajuste no cadastro' };
  const data = dataCurta(contract.nextAdjustmentDate);
  const indice = contract.adjustmentIndex ? ` (${contract.adjustmentIndex})` : '';
  if (isAdjustmentDue(contract, diasAte)) return { texto: 'vencido', tom: 'vencido', dica: `Reajuste devido desde ${data}${indice}` };
  if (diasAte !== null && diasAte > 0 && diasAte <= 30) return { texto: `em ${diasAte}d`, tom: 'proximo', dica: `Próximo reajuste em ${data}${indice}` };
  const conferido = contract.adjustmentVerificationStatus && contract.adjustmentVerificationStatus !== 'nao_conferido';
  return { texto: data, tom: 'ok', dica: `Próximo reajuste em ${data}${indice}${conferido ? '' : ' · data-base ainda não conferida no documento'}` };
}

/**
 * Sobre qual item o desconto incide. O vínculo está no cadastro
 * (`discountTargetProductId`, escolhido na edição); a ficha só não mostrava.
 * Prefere o nome do item da própria assinatura, que é o que a pessoa lê na linha
 * de cima; cai para o nome do produto.
 */
export function alvoDoDesconto(item: any, items: any[], products: any[]): string | null {
  const alvo = item?.discountTargetProductId;
  if (!alvo) return null;
  const naAssinatura = (items || []).find((i) => Number(i.productId) === Number(alvo));
  const prod = products.find((p) => Number(p.id) === Number(alvo));
  return naAssinatura?.name || prod?.name || prod?.code || null;
}
